<template>
  <pui-flex
    class="pui-template-toolbar"
    wrap="wrap"
    justifyContent="center"
    alignItems="start"
    alignContent="start"
  >
    <pui-button
      v-for="componentButton in componentButtons"
      :picto="componentButton.picto"
      :key="componentButton.id"
      :title="componentButton.type"
      :style="componentButton.style"
      :disabled="disabled"
      @click="$emit('insertComponent', componentButton.value)"
      variant="primary"
      class="toolbar-btn"
    >
    </pui-button>
  </pui-flex>
</template>

<script>
export default {
  name: 'pui-template-toolbar',
  props: {
    disabled: {
      type: Boolean,
    },
  },
  data() {
    return {
      componentButtons: [
        {
          id: 'text',
          type: 'Text',
          picto: 'mdi-alpha-a',
          value: {
            type: 'text',
            x: 0,
            y: 0,
            width: 50,
            height: 50,
            fontSizeMax: 12,
            binding: 'YOUR_BINDING',
            angle: 0,
            scale: {
              x: 1,
              y: 1,
            },
            anchor: {
              anchorPoint: '',
              reference: '',
              referencePoint: '',
              offset: {
                x: 0,
                y: 0,
              },
            },
          },
        },
        {
          id: 'steptext',
          type: 'StepText',
          picto: 'mdi-alpha-b',
          value: {
            type: 'steptext',
            x: 0,
            y: 0,
            width: 200,
            height: 100,
            fontSizeMax: 30,
            binding: 'YOUR_BINDING',
            suffix: ' ',
            angle: 0,
            scale: {
              x: 1,
              y: 1,
            },
            steps: [
              {
                fontSize: 30,
                maxCharacters: 33,
              },
              {
                fontSize: 24,
                maxCharacters: 65,
              },
            ],
            sizeLimits: {
              maxHeight: 100,
              minHeight: 30,
            },
          },
        },
        {
          id: 'rectangle',
          type: 'Rectangle',
          picto: 'mdi-rectangle-outline',
          value: {
            type: 'rectangle',
            angle: 0,
            fill: '#65b32e',
            height: 24.32323232323232,
            isNotPrintable: true,
            scale: {
              x: 1,
              y: 1,
            },
            width: 297,
            x: 0,
            y: 0,
          },
        },
        {
          id: 'line',
          type: 'Line',
          picto: 'mdi-vector-line',
          value: {
            type: 'path',
            angle: 0,
            x: 50,
            y: 68,
            width: 110,
            height: 132,
            d: 'M 15 0 H 0 V 129 H 107 V 0 H 92',
            stroke: '#001f7f',
            strokeWidth: '6',
            fill: '#FFF',
            scale: {
              x: 1,
              y: 1,
            },
            isNotPrintable: false,
          },
        },
        {
          id: 'path',
          type: 'Path',
          picto: 'mdi-vector-polyline',
          value: {
            type: 'path',
            angle: 0,
            x: 50,
            y: 68,
            width: 110,
            height: 132,
            d: 'M 15 0 H 0 V 129 H 107 V 0 H 92',
            stroke: '#001f7f',
            strokeWidth: '6',
            fill: '#FFF',
            scale: {
              x: 1,
              y: 1,
            },
            isNotPrintable: false,
          },
        },
        {
          id: 'ellipse',
          type: 'Ellipse',
          picto: 'mdi-ellipse-outline',
          value: {
            type: 'ellipse',
            angle: 0,
            x: 105,
            y: 90,
            width: 150,
            height: 150,
            rx: 70,
            fill: '#fff',
            isNotPrintable: false,
            scale: {
              x: 1,
              y: 1,
            },
          },
        },
        {
          id: 'image',
          type: 'Image',
          picto: 'mdi-image',
          value: {
            type: 'image',
            id: 'brand_image',
            x: 0,
            y: 0,
            width: 'auto',
            height: 3,
            sizeLimits: {
              minWidth: 20,
              maxWidth: 40,
            },
            isNotPrintable: false,
            preserveProportions: true,
            url:
              'https://imagesressource.intersport.fr/v2/_ui/responsive/theme-intersport-fr-v2/img/logo_is.svg',
            visibility: 'true',
            angle: 0,
            scale: {
              x: 1,
              y: 1,
            },
          },
        },
        {
          id: 'stacklayout',
          type: 'StackLayout',
          picto: 'mdi-page-layout-header-footer',
          value: {
            type: 'stackLayout',
            orientation: 'vertical',
            x: 14,
            y: 0,
            width: 182,
            height: 15,
            components: [],
          },
        },
        {
          id: 'wraplayout',
          type: 'WrapLayout',
          picto: 'mdi-page-layout-header-footer',
          style: 'transform: rotate(90deg)',
          value: {
            type: 'wraplayout',
            x: 0,
            y: 0,
            angle: 0,
            scale: {
              x: 1,
              y: 1,
            },
            orientation: 'vertical',
            width: 200,
            height: 200,
            id: 'WrapLayout',
            components: [],
          },
        },
        {
          id: 'component',
          type: 'Component',
          picto: 'mdi-alpha-c',
          value: {
            type: 'component',
            x: 150,
            y: 140,
            width: 50,
            height: 50,
            angle: 0,
            scale: {
              x: 1,
              y: 1,
            },
          },
          components: [],
        },
        {
          id: 'genericbarcode',
          type: 'GenericBarcode',
          picto: 'mdi-data-matrix',
          value: {
            type: 'generic_barcode',
            barcodeId: 'ean13',
            x: 150,
            y: 140,
            width: 50,
            height: 50,
            binding: 'YOUR_BINDING',
            angle: 0,
            scale: {
              x: 1,
              y: 1,
            },
            barcodeOptions: {
              barcolor: 'ff0000',
            },
          },
        },
      ],
    };
  },
};
</script>
